// components/PlayButton.tsx
import React from "react";
import { Button, ButtonProps } from "@chakra-ui/react";
import { IoMdPlayCircle } from "react-icons/io";
import { useSound } from "providers/SoundProvider";

interface PlayButtonProps extends ButtonProps {
  label: string;
  onClick: () => void;
  colorScheme?: string;
  mb?: number;
}

const PlayButton: React.FC<PlayButtonProps> = ({
  label,
  onClick,
  colorScheme = "red",
  mb = 4,
  ...props
}) => {
  const { isAudioPlaying } = useSound();

  return (
    <Button
      leftIcon={<IoMdPlayCircle />}
      width={"100%"}
      onClick={onClick}
      isDisabled={isAudioPlaying}
      colorScheme={colorScheme}
      backgroundColor={"primary"}
      mb={mb}
      size={"lg"}
      py={6}
      borderRadius={"full"}
      fontSize={"sm"}
      {...props}
    >
      {label}
    </Button>
  );
};

export default PlayButton;
